import { render } from "./CustomSelectOneSemenType.vue?vue&type=template&id=1555cf34"
import script from "./CustomSelectOneSemenType.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneSemenType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__